import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router';
import { useAuth } from '../auth/AuthContext';
import { usePageTitle } from '../lib/title';
import { Viewer } from '../viewer/Viewer';

export function OperatorViewerPage() {
  const { id } = useParams<{ id: string }>();
  const [params] = useSearchParams();
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  usePageTitle('뷰어');
  if (!id) return <Navigate to="/profiles" replace />;
  return (
    <div className="h-screen">
      <Viewer
        profileId={id}
        variant="operator"
        isAdmin={isAdmin}
        initialTabId={params.get('tab') ?? undefined}
        supportSessionId={params.get('supportSessionId') ?? undefined}
        exitLabel="프로필"
        onExit={() => navigate(`/profiles/${id}`)}
      />
    </div>
  );
}
